import { render, staticRenderFns } from "./ControlBar.vue?vue&type=template&id=54005622&"
import script from "./ControlBar.vue?vue&type=script&lang=ts&"
export * from "./ControlBar.vue?vue&type=script&lang=ts&"
import style0 from "./ControlBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports